export default __webpack_public_path__ + "static/mfaa-e7e01d856fa9a5518369b32e6afc5152.svg";